import * as React from 'react';

import * as DetailFormCommon from './common';

export const InventoryDetailFormComponentDetailsAssociation = ({
    sectionTitle,
    ...rest }) => {

    return (
        <DetailFormCommon.InventoryDetailFormSection title={sectionTitle}>
            <div>
                {rest.children}
            </div>
        </DetailFormCommon.InventoryDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/inventory/detail-form/component-details-association.tsx